// in MessageParser.js
import React from 'react';

const MessageParser = ({ children, actions } : any) => {
  const parse = (message : any) => {
      
      actions.handelChoise()
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions,
        });
      })}
    </div>
  );
};

export default MessageParser;